import React, { useState, useContext, useEffect, useCallback } from 'react';
import {
    Dialog,
    Slide,
    AppBar,
    IconButton,
    Typography,
    Toolbar,
    Button,
    List,
    ListItem,
    ListItemText,
    Divider,
    Drawer,
    Box
} from "@mui/material";
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from "@mui/icons-material/Close";
import { ReservationContext } from '../../../contexts/reservation.context';
import { makeStyles } from '@mui/styles';
import OutMenu from "../menu/owner.menu.outmenu";
import RoomCart from "./owner.room.dialog.cart.mobile";
import DishVariantsSelector from '../../user/reservation/DishVariantsSelector';

const useStyles = makeStyles((theme) => ({
    sectionContainer: {
        marginTop: theme.spacing(6) + ' !important',
        paddingTop: '20px',
        backgroundColor: '#303030 !important',
        minHeight: '100vh'
    },
    sectionTitle: {
        marginBottom: theme.spacing(0.5) + ' !important',
        fontWeight: 'bold',
        textTransform: 'capitalize'
    },
    categoryTab: {
        maxWidth: 240,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    list: { width: 250 },
    colorTextCategories: { color: theme.palette.primary.main + ' !important', fontVariant: 'small-caps' },
    SelectedCategory: { color: theme.palette.primary.main + ' !important', boxShadow: '2px 1px 1px rgba(0,0,0,0.3)' },
    NoSelectedCategory: { boxShadow: '2px 1px 1px rgba(0,0,0,0.3)' },
    numberOrder: {
        color: '#fff',
        backgroundColor: 'red',
        borderRadius: '50%',
        height: '22px',
        width: '22px',
        textAlign: 'center',
        marginLeft: '10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: '-5px',
        right: '-5px',
        fontSize: '0.7rem'
    },
    appBarMenu: { backgroundColor: '#000 !important' },
    dishGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5),
    },

    dishItem: {
        position: 'relative',
        borderRadius: theme.spacing(1.5),
        backgroundColor: '#1e1e1e',
        color: '#fff',
        minHeight: 80,
        padding: theme.spacing(1.5),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        fontWeight: 600,
        textTransform: 'capitalize',
        boxShadow: '0 4px 10px rgba(0,0,0,0.35)',
        transition: 'all .18s ease',
        cursor: 'pointer',

        '&:hover': {
            backgroundColor: '#262626',
            boxShadow: '0 6px 14px rgba(0,0,0,0.45)',
            transform: 'translateY(-2px)',
        },

        '&:active': {
            transform: 'scale(0.97)',
            boxShadow: '0 2px 6px rgba(0,0,0,0.5)',
        },

        '&:focus-visible': {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: 2,
        }
    },

    dishName: {
        fontSize: '0.95rem',
        lineHeight: 1.2,
    },

    amountBadge: {
        position: 'absolute',
        top: 8,
        right: 8,
        backgroundColor: theme.palette.primary.main,
        color: '#000',
        borderRadius: '50%',
        width: 22,
        height: 22,
        fontSize: '0.75rem',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 6px rgba(0,0,0,0.4)',
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function DialogMenuMobile({ openDialog, setOpenDialog, handleClickOrder, tableId, dataMenuObj, ownerId, table }) {
    const classes = useStyles();
    const { addToCart, cart, setCart } = useContext(ReservationContext);

    // Stati Menu
    const [dish, setDish] = useState([]);
    const [categorySelected, setCategorySelected] = useState("");
    const [selectedCategory, setSelectedCategory] = useState(0);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Stati Varianti (Allineati al Desktop)
    const [dialogDish, setDialogDish] = useState(null);
    const [variantsSelection, setVariantsSelection] = useState([]);
    const [openVariantsDialog, setOpenVariantsDialog] = useState(false);
    const [deletedNotes, setDeletedNotes] = useState("");
    const [deletedOptionIds, setDeletedOptionIds] = useState([]);

    const [amountTotalCart, setAmountTotalCart] = useState({});
    const [showOutMenu, setShowOutMenu] = useState(false);
    const [openCartDialog, setOpenCartDialog] = useState(false);

    const safeVariants = Array.isArray(dialogDish?.variants) ? dialogDish.variants : [];

    useEffect(() => {
        if (dataMenuObj?.categories?.length > 0) {
            const firstCat = dataMenuObj.categories[0];
            getNameDish(firstCat.id, firstCat.name);
            setSelectedCategory(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataMenuObj]);

    const getNameDish = (categoryId, nameCategoria) => {
        setCategorySelected(nameCategoria);
        let filterDish = dataMenuObj.dataMenu
            .filter(el => el.categoryId === categoryId)
            .sort((a, b) => a.name.localeCompare(b.name));
        setDish(filterDish);
    }

    const handleClickNameDish = (dishItem) => {
        if (!dishItem.variants) dishItem.variants = [];

        // Ordina opzioni varianti
        dishItem.variants.forEach(v => {
            v.options.sort((a, b) => a.label.toLowerCase().trim().localeCompare(b.label.toLowerCase().trim()));
        });

        if (dishItem.variants.length > 0) {
            dishItem.variants.sort((a, b) => a.position - b.position);
            setDialogDish(dishItem);
            setVariantsSelection([]);
            setDeletedNotes("");
            setDeletedOptionIds([]);
            setOpenVariantsDialog(true);
        } else {
            addToCart({ ...dishItem, amount: 1, note: "" });
        }
    }

    const handleConfirmVariants = () => {
        if (!dialogDish) return;

        const variantsForCart = safeVariants.map(v => {
            const selected = variantsSelection.find(sel => sel.id === v.id)?.selected;
            const currentVariantDeletedIds = deletedOptionIds.filter(id =>
                v.options.some(opt => opt.id === id)
            );

            if ((!selected || selected.length === 0) && currentVariantDeletedIds.length === 0) {
                return null;
            }

            return {
                ...v,
                selected: selected || [],
                deletedOptions: currentVariantDeletedIds
            };
        }).filter(Boolean);

        addToCart({
            ...dialogDish,
            amount: 1,
            note: deletedNotes || "",
            variants: variantsForCart,
        });

        setOpenVariantsDialog(false);
        setDialogDish(null);
    };

    const getAmountTotal = useCallback((totalCart) => {
        const amountMap = {};
        totalCart.forEach((d) => {
            amountMap[d.id] = (amountMap[d.id] || 0) + d.amount;
        });
        setAmountTotalCart(prev => JSON.stringify(prev) === JSON.stringify(amountMap) ? prev : amountMap);
    }, []);

    return (

        <Dialog onClose={handleClickOrder} TransitionComponent={Transition} fullScreen open={openDialog}>

            {/* Header Principale */}
            <AppBar position="sticky">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClickOrder}><CloseIcon /></IconButton>
                    <Typography variant="h6">
                        {(table?.tableId || table?.id) ? 'Tavolo ' + (table?.tableId || table?.id) : table?.deliveryId ? (table?.tipo + ' ' + table?.nome + ' ' + table?.cognome) : 'Nuova consegna'}
                    </Typography>
                </Toolbar>
            </AppBar>

            {/* Tab Categorie */}
            <AppBar position="fixed" style={{ top: "56px" }} className={classes.appBarMenu}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={() => setIsMenuOpen(true)}><MenuIcon /></IconButton>
                    <Tabs value={selectedCategory} onChange={(e, v) => setSelectedCategory(v)} variant='scrollable' scrollButtons='auto'>
                        {dataMenuObj.categories.map(({ id, name }) => (
                            <Tab key={id} onClick={() => getNameDish(id, name)} label={<Typography className={classes.categoryTab}>{name}</Typography>} />
                        ))}
                    </Tabs>
                </Toolbar>
            </AppBar>

            {/* Menu Laterale Drawer */}
            <Drawer style={{ zIndex: 999999 }} anchor='left' open={isMenuOpen} onClose={() => setIsMenuOpen(false)}>
                <div className={classes.list}>
                    <List>
                        <ListItem><ListItemText className={classes.colorTextCategories} primary='Scegli la categoria' /></ListItem>
                        <Divider />
                        {dataMenuObj.categories.map(({ id, name }, index) => (
                            <ListItem button key={id} onClick={() => { getNameDish(id, name); setSelectedCategory(index); setIsMenuOpen(false); }} className={selectedCategory === index ? classes.SelectedCategory : classes.NoSelectedCategory}>
                                <ListItemText primary={name} style={{ textTransform: 'capitalize' }} />
                            </ListItem>
                        ))}
                    </List>
                </div>
            </Drawer>

            {/* Lista Piatti */}
            <div className={classes.sectionContainer}>
                <Typography
                    variant="h6"
                    align="center"
                    className={classes.sectionTitle}
                >
                    {categorySelected}
                </Typography>

                <div className={classes.dishGrid}>
                    {dish.map((item) => (
                        <Box
                            key={item.id}
                            className={classes.dishItem}
                            onClick={() => handleClickNameDish(item)}
                        >
                            <Typography className={classes.dishName}>
                                {item.name}
                            </Typography>

                            {amountTotalCart[item.id] && (
                                <div className={classes.amountBadge}>
                                    {amountTotalCart[item.id]}
                                </div>
                            )}
                        </Box>
                    ))}
                </div>
            </div>

            <OutMenu dishes={cart} setDishes={setCart} setShowOutMenu={setShowOutMenu} showOutMenu={showOutMenu} />
            <RoomCart getAmountTotal={getAmountTotal} setOpenCartDialog={setOpenCartDialog} cart={cart} handleClickOrder={handleClickOrder} openCartDialog={openCartDialog} tableId={(table?.tableId || table?.id)} deliveryId={table?.deliveryId} ownerId={ownerId} />

            {/* DIALOG VARIANTI (Uguale al Desktop) */}
            {dialogDish && (
                <Dialog open={openVariantsDialog} fullScreen onClose={() => setOpenVariantsDialog(false)} TransitionComponent={Transition}>
                    <AppBar position="sticky">
                        <Toolbar>
                            <Typography variant="h6" style={{ flexGrow: 1 }}>{dialogDish.name}</Typography>
                            <IconButton edge="end" color="inherit" onClick={() => setOpenVariantsDialog(false)}><CloseIcon /></IconButton>
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ p: 0, pb: 15, bgcolor: '#303030', minHeight: '100vh', color: '#fff' }}>
                        <DishVariantsSelector
                            dish={{ ...dialogDish, variants: safeVariants }}
                            variantsSelection={variantsSelection}
                            setVariantsSelection={setVariantsSelection}
                            mode="owner"
                            onDeletedNotesChange={(notes, deletedIds) => {
                                setDeletedNotes(notes);
                                setDeletedOptionIds(deletedIds || []);
                            }}
                        />
                    </Box>
                    <Box sx={{ position: 'fixed', bottom: 0, width: '100%', p: 2, bgcolor: '#000', zIndex: 2000 }}>
                        <Button fullWidth variant="contained" color="primary" onClick={handleConfirmVariants} sx={{ py: 1.5, fontSize: 18 }}>
                            Aggiungi al carrello
                        </Button>
                    </Box>
                </Dialog>
            )}
        </Dialog>

    );
}

export default DialogMenuMobile;